(function () {
  var ROOT_SELECTOR = "[data-progress-slide-root]";
  var INIT_FLAG = "progressSlideInited";

  function setActive(root, index) {
    var items = root.querySelectorAll("[data-slide-item]");
    var dots = root.querySelectorAll("[data-progress-dot]");
    var count = dots.length;

    if (!count) return;

    var nextIndex = ((index % count) + count) % count;
    root.dataset.activeIndex = String(nextIndex);
    
    var isDragging = root.dataset.isDragging === "true";
    var targetPercent = ((nextIndex + 1) / (count + 1)) * 100;

    items.forEach(function (item) {
      var itemIndex = Number(item.getAttribute("data-index") || 0);
      item.classList.toggle("is-active", itemIndex === nextIndex);
      
      if (item.classList.contains("progress-mover") && !isDragging) {
        item.style.left = targetPercent + "%";
      }
    });

    dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === nextIndex;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-selected", active ? "true" : "false");
    });
  }

  function layoutTrackItems(root) {
    var dots = root.querySelectorAll("[data-progress-dot]");
    var count = dots.length;
    if (!count) return;

    dots.forEach(function (dot, index) {
      var percent = ((index + 1) / (count + 1)) * 100;
      dot.style.left = percent + "%";
    });
  }

  function initProgressSlide(root) {
    if (!root || root.dataset[INIT_FLAG] === "true") return;

    var dots = root.querySelectorAll("[data-progress-dot]");
    var prevBtn = root.querySelector("[data-progress-prev]");
    var nextBtn = root.querySelector("[data-progress-next]");
    var count = dots.length;
    if (!count) return;
    root.dataset[INIT_FLAG] = "true";

    layoutTrackItems(root);
    setActive(root, 0);

    function handleManualChange(nextIndex) {
      setActive(root, nextIndex);
      restartTimer();
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        handleManualChange(Number(dot.getAttribute("data-index") || 0));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        var current = Number(root.dataset.activeIndex || 0);
        handleManualChange(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        var current = Number(root.dataset.activeIndex || 0);
        handleManualChange(current + 1);
      });
    }

    // --- Drag functionality for progress track ---
    var track = root.querySelector(".progress-track-wrap");
    var movers = root.querySelectorAll(".progress-mover");
    if (track && movers.length > 0) {
      var isDragging = false;
      
      function getPercentFromEvent(e) {
        var rect = track.getBoundingClientRect();
        var clientX = e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
        var x = clientX - rect.left;
        var percent = (x / rect.width) * 100;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        return percent;
      }
      
      function getIndexFromPercent(percent) {
        var rawIndex = (percent / 100) * (count + 1) - 1;
        var index = Math.round(rawIndex);
        if (index < 0) index = 0;
        if (index >= count) index = count - 1;
        return index;
      }

      function updateMoversLeft(percent) {
        movers.forEach(function(m) {
          m.style.left = percent + "%";
        });
      }

      function onDragStart(e) {
        if (e.target.closest(".progress-arrow")) return;
        if (e.type === "mousedown") {
          if (e.button !== 0) return;
          e.preventDefault(); // 阻止PC端浏览器默认的图片拖拽或文本选中行为
        }
        isDragging = true;
        root.dataset.isDragging = "true";
        track.classList.add("is-dragging");
        movers.forEach(function(m) { m.classList.add("no-transition"); });
        clearTimer();
        
        var percent = getPercentFromEvent(e);
        updateMoversLeft(percent);
        
        var index = getIndexFromPercent(percent);
        var current = Number(root.dataset.activeIndex || 0);
        if (index !== current) {
          setActive(root, index);
        }
      }

      function onDragMove(e) {
        if (!isDragging) return;
        if (e.cancelable && e.type === "touchmove") {
          e.preventDefault();
        }
        var percent = getPercentFromEvent(e);
        updateMoversLeft(percent);
        
        var index = getIndexFromPercent(percent);
        var current = Number(root.dataset.activeIndex || 0);
        if (index !== current) {
          setActive(root, index);
        }
      }

      function onDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        root.dataset.isDragging = "false";
        track.classList.remove("is-dragging");
        
        // Force reflow so transition is re-enabled starting from current dragged position
        track.offsetHeight;
        movers.forEach(function(m) { m.classList.remove("no-transition"); });
        
        var current = Number(root.dataset.activeIndex || 0);
        var targetPercent = ((current + 1) / (count + 1)) * 100;
        updateMoversLeft(targetPercent);
        
        restartTimer();
      }

      track.addEventListener("mousedown", onDragStart);
      window.addEventListener("mousemove", onDragMove, { passive: false });
      window.addEventListener("mouseup", onDragEnd);

      track.addEventListener("touchstart", onDragStart, { passive: true });
      window.addEventListener("touchmove", onDragMove, { passive: false });
      window.addEventListener("touchend", onDragEnd);
      window.addEventListener("touchcancel", onDragEnd);
    }

    // --- Swipe functionality for the whole section ---
    var startX = 0;
    var startY = 0;
    var isSwiping = false;

    root.addEventListener("touchstart", function (e) {
      if (e.touches.length > 1 || e.target.closest(".progress-track-wrap")) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwiping = true;
    }, { passive: true });

    root.addEventListener("touchmove", function (e) {
      if (!isSwiping) return;
      var diffX = e.touches[0].clientX - startX;
      var diffY = e.touches[0].clientY - startY;
      if (Math.abs(diffY) > Math.abs(diffX)) {
        isSwiping = false;
        return;
      }
      if (e.cancelable && Math.abs(diffX) > 10) {
        e.preventDefault();
      }
    }, { passive: false });

    root.addEventListener("touchend", function (e) {
      if (!isSwiping) return;
      isSwiping = false;
      var diffX = e.changedTouches[0].clientX - startX;
      if (Math.abs(diffX) > 50) {
        var current = Number(root.dataset.activeIndex || 0);
        if (diffX > 0) {
          handleManualChange(current - 1);
        } else {
          handleManualChange(current + 1);
        }
      }
    });

    var autoplayRaw = (root.dataset.autoplay || "").toLowerCase();
    var autoplay = autoplayRaw === "true" || autoplayRaw === "1";
    var interval = Number(root.dataset.interval || 4000);
    if (!Number.isFinite(interval) || interval < 500) {
      interval = 4000;
    }
    var timer = null;

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function shouldPauseAutoplay() {
      return document.hidden;
    }

    function restartTimer() {
      clearTimer();
      if (!autoplay || count < 2 || shouldPauseAutoplay()) return;
      timer = window.setTimeout(function () {
        var current = Number(root.dataset.activeIndex || 0);
        setActive(root, current + 1);
        restartTimer();
      }, interval);
    }

    document.addEventListener("visibilitychange", restartTimer);

    restartTimer();
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    roots.forEach(initProgressSlide);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root) initProgressSlide(root);
  });
})();
